import * as selector from "./selector";
import { Headers } from "./header";

const apiUrl = process.env.REACT_APP_API_URL;

export const auth = `${apiUrl}/auth/api`;
export const dictionary = `${apiUrl}/dictionary/api`;
export const app = `${apiUrl}/app/api`;
export const image = `${apiUrl}/`;

export {selector,Headers,};
